module.exports = __webpack_public_path__ + "media/customizations/lewiscommunities/logo-8eba81781a093001391c185ec8df2cac.png";